







































import { computed, defineComponent, ref, onMounted } from "@vue/composition-api";
import useDeviceData, { Detectors } from "@/store/modules/useDeviceData";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { app } from "@/store/index";
import useUserSettings from "@/store/useUserSettings";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";
import { alarm, sensor, enrollState } from '@/store';
import { enrollUi } from '@/store/enrollUi';

export default defineComponent({
    components: {
        SensorItem: () => import("./Sensors/DefaultSensorListItem.vue"),
        GasSensorItem: () => import("./Sensors/GasSensorListItem.vue")
    },
    setup() {
        const { getDetectorData } = useDeviceData();
        const { getUserSettings, updateUserSettings } = useUserSettings();

        // Load on mount and keep a local ref
        const userSettings = ref<UserSettingsViewModel | null>(null);

        onMounted(async () => {
            try {
                userSettings.value = await getUserSettings();
            } catch (e) {
                console.error("Failed to load user settings", e);
            }
        });

        const heatModel = computed<AttachedDeviceModel>(() => getDetectorData(Detectors.heat));
        const coModel = computed<AttachedDeviceModel>(() => getDetectorData(Detectors.co));
        const smokeModel = computed<AttachedDeviceModel>(() => getDetectorData(Detectors.smoke));
        const waterModel = computed<AttachedDeviceModel>(() => getDetectorData(Detectors.water));
        const gasModel = computed<AttachedDeviceModel>(() => getDetectorData(Detectors.gas));

        function openDialog(payload: { typeId: number; img: string }) {
            enrollState.startEnrollment(payload.typeId);
            enrollUi.open(payload.img);
        }

        function unpair(payload: { deviceId: string }) {
            sensor.UnpairDevice(payload.deviceId);
        }

        // Update and persist gas threshold
        const handleOnNewGasThreshold = async (model: UserSettingsViewModel) => {
            try {
                // Ensure we have a local settings object
                userSettings.value = userSettings.value ?? { ...model };
                userSettings.value.gasThreshold = model.gasThreshold;

                // Send to device as HEX string eg "0BB8" for 3000
                alarm.setGasThreshold(model.gasThreshold.toString(16).padStart(4, '0').toUpperCase());

                // Persist to backend
                await updateUserSettings(userSettings.value);
            } catch (err) {
                app.error = "Failed to update gas sensitivity.";
                console.error("Error updating gas threshold:", err);
            }
        };

        const panel = computed<number>(() => (app.getSensorsPanelOpen ? app.getSensorsPanelIndex : -1));

        return {
            heatModel,
            coModel,
            smokeModel,
            waterModel,
            gasModel,
            panel,
            openDialog,
            unpair,
            handleOnNewGasThreshold,
        };
    }
});
